import { Div, Spinner } from "@tblabs/truffle";


export class Loader extends Div
{
    constructor(text: string = "Ładowanie...")
    {
        super();

        this.Append(
            new Spinner().MarginRight(8),
            text,
        )
    }
}
